(() => {
  'use strict';

  // Only the standard frame uses this fixed 24-media layout.
  if (!location.pathname.endsWith('/products/standard-echtholzrahmen')) return;

  const gallery = document.querySelector('main product-gallery[form]');
  const form = gallery && document.getElementById(gallery.getAttribute('form'));
  const carousel = gallery && gallery.querySelector('.product-gallery__carousel');
  if (!form || !carousel || typeof carousel.filter !== 'function') return;

  const media = Array.from(carousel.querySelectorAll(':scope > .product-gallery__media'));
  if (media.length !== 24) return; // Never apply a positional map to a changed media set.

  function selectedOptionIndex(position, expectedCount) {
    const options = Array.from(form.elements).filter((element) =>
      element.getAttribute('data-option-position') === String(position)
    );
    if (options.length !== expectedCount) return -1;
    return options.findIndex((option) => option.checked);
  }

  function updateGallery() {
    const color = selectedOptionIndex(1, 3); // Natur, Schwarz, Weiß
    const size = selectedOptionIndex(2, 5);  // A4, A3, A2, A1, 50 × 70
    if (color < 0 || size < 0) return;

    // Shopify media positions are one-based; Prestige's carousel indexes are zero-based.
    const visiblePositions = new Set([
      color * 5 + size + 1, // Front: 1–15
      16 + color,           // Color detail: 16–18
      19 + size,            // Size back: 19–23
      24                   // Universal comparison
    ]);
    const filteredIndexes = media.flatMap((_, index) =>
      visiblePositions.has(index + 1) ? [] : [index]
    );

    // Keep Prestige's own variant-change calculations and all gallery controls in sync.
    gallery.setAttribute('filtered-indexes', JSON.stringify(filteredIndexes.map((index) => index + 1)));
    carousel.filter(filteredIndexes);
    carousel.select(0, { instant: true });

    gallery.querySelectorAll('product-gallery-navigation, carousel-navigation').forEach((navigation) => {
      Array.from(navigation.querySelectorAll('button:not([hidden])')).forEach((button, index) => {
        button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      });
    });
  }

  updateGallery();
  form.addEventListener('variant:change', updateGallery);
  form.addEventListener('product:rerender', updateGallery);
})();
